import React from 'react';

export default function Card({ children, style, padding = 'var(--sp-2xl)', onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: 'linear-gradient(145deg, #fff 0%, #faf9fb 100%)',
        borderRadius: 'var(--radius-lg)',
        padding,
        border: '1px solid var(--color-border)',
        boxShadow: 'var(--shadow-sm)',
        ...(onClick ? { cursor: 'pointer', transition: 'box-shadow var(--transition-fast)' } : {}),
        ...style,
      }}
      onMouseEnter={(e) => { if (onClick) e.currentTarget.style.boxShadow = 'var(--shadow-lg)'; }}
      onMouseLeave={(e) => { if (onClick) e.currentTarget.style.boxShadow = 'var(--shadow-md)'; }}
    >
      {children}
    </div>
  );
}
